module.exports = __webpack_public_path__ + "static/media/lemonrice.478c75a8.jpg";